'use strict'
import { Controller } from '../config/app.js'
import { hasRole } from '../helper.js'

class PasswordrecoveryController extends Controller
{
	async confirm()
	{
		if (!hasRole('Guest'))
		{
			location.href = location.origin
			return
		}

		if (this.view.model.search?.new)
			return App.Store.fetch('topic', 'Apex.PasswordNew')
				.finally(() => this.view.render())

		this.view.render()
	}
}

export { PasswordrecoveryController }
